<template>
  <div>
    <component
      v-if="currentComponent"
      :is="currentComponent.component"
      v-bind="currentComponent.props"
    />
  </div>
</template>

<script>
import AwsSpuReviewMain from '@/views/ecom/base/awsspuReview/components/detail/main.vue'
import AwsSku from '@/views/ecom/base/awsGoods/components/aws-sku'
import FabricReviewEditForm from '@/views/ecom/awsSample/fabricReview/components/edit-form'
import FabricSeriesEditForm from '@/views/ecom/awsSample/fabricSeries/components/edit-form'
import EvgSpuReviewMain from '@/views/ecom/base/evgspuReview/components/detail/main.vue'
import EvgGoodInfo from '@/views/ecom/base/evgGoods/components/evg-good-info'
import SkuFirstOrderReview from '@/views/ecom/awsBiz/skuFirstOrderReview/components/edit-form'
export default {
  components: {
    AwsSpuReviewMain,
    AwsSku,
    FabricReviewEditForm,
    FabricSeriesEditForm,
    EvgSpuReviewMain,
    EvgGoodInfo,
    SkuFirstOrderReview,
  },
  props: {
    businessType: { type: String, default: '' },
    businessCode: { type: String, default: '' },
  },
  computed: {
    componentMaps() {
      return {
        ECOM_AMZ_SPU: {
          component: 'AwsSpuReviewMain',
          props: { type: 'detail', amzSpuCode: this.businessCode },
        },
        ECOM_AMZ_SKU: {
          component: 'AwsSku',
          props: { disabled: true, amzSkuCode: this.businessCode },
        },
        ECOM_AMZ_FABRIC: {
          component: 'FabricReviewEditForm',
          props: { disabled: true, fabricCode: this.businessCode },
        },
        ECOM_AMZ_FABRIC_SERIES: {
          component: 'FabricSeriesEditForm',
          props: {
            formDisabled: true,
            imageDisabled: true,
            fabricDisabled: true,
            fabricSeriesCode: this.businessCode,
          },
        },
        ECOM_EVG_SPU: {
          component: 'EvgSpuReviewMain',
          props: { type: 'detail', evgSpuCode: this.businessCode },
        },
        ECOM_EVG_SKU: {
          component: 'EvgGoodInfo',
          props: { disabled: true, evgSkuCode: this.businessCode },
        },
        ECOM_AMZ_FIRST_DEMAND: {
          component: 'SkuFirstOrderReview',
          props: {
            disabled: true,
            amzFirstDemandCode: this.businessCode,
            pageType: 'detail',
          },
        },
      }
    },
    currentComponent() {
      return this.componentMaps[this.businessType] || null
    },
  },
}
</script>

<style lang="scss" scoped></style>
